/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Care_Logs_TitleInputs */

const vi_trace_care_logs_title = /** @type {(inputs: Trace_Care_Logs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký chăm sóc`)
};

/**

* @param {Trace_Care_Logs_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_care_logs_title = /** @type {((inputs?: Trace_Care_Logs_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Care_Logs_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_care_logs_title(inputs)
});